import { render, staticRenderFns } from "./costCenter.vue?vue&type=template&id=5da67d76"
import script from "./costCenter.vue?vue&type=script&lang=js"
export * from "./costCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports